import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import LeftTree from '../../bill-settings/components/LeftTree'
import { FieldSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import '../../bill-settings/components/bill.less'
import './index.less'
import { deepClone } from '@/utils'

const fssp = new FieldSettingServiceProxy()

const defaultList = [
  {
    bizType: 'plan-report',
    code: 'extend1',
    isDisplay: 0,
    name: '自定义字段1'
  }, {
    bizType: 'plan-report',
    code: 'extend2',
    isDisplay: 0,
    name: '自定义字段2'
  }, {
    bizType: 'plan-report',
    code: 'extend3',
    isDisplay: 0,
    name: '自定义字段3'
  }
]

@Component({
  components: {
    LeftTree
  }
})
export default class BillSettings extends Vue {
  @Prop() menuId: string

  loading = false
  data = []
  bizType = ''

  get columns() {
    return [
      {
        title: this.$t('page_bill_manage_no'),
        dataIndex: 'code',
        key: 'code',
        width: 110
      },
      {
        title: this.$t('page_bill_manage_title'),
        dataIndex: 'name',
        key: 'name',
        width: 160,
        customRender: (text, record, index) => {
          return (
            <a-input
              value={text}
              maxLength={255}
              style="width: 100%"
              onChange={e => this.handleChange(e.target.value, index, 'name')}
              placeholder={this.$t('page_material_warehousing_p_input')}
            />
          )
        }
      },
      {
        title: this.$t('page_resource_pool_show'),
        dataIndex: 'isDisplay',
        key: 'isDisplay',
        width: 160,
        customRender: (text, record, index) => {
          let isChecked = !!(text === 1)
          return (
            <a-switch checked={isChecked} onChange={e => this.handleChange(e, index, 'isDisplay')}/>
          )
        }
      }
    ]
  }

  async getTableList(value?) {
    console.log(1111, value)
    if (value) {
      this.bizType = value.title
      let res = await fssp.listFieldSettings(value.title)
      defaultList.map(item => item.bizType = this.bizType)
      this.data = res && res.length ? res : defaultList
    }

  }

  handleChange(val, index, col) {
    console.log(val, index, col)
    let temp = deepClone(this.data)
    temp[index][col] = val
    if (col === 'isDisplay') {
      temp[index][col] = val ? 1 : 0
    }
    this.data = deepClone(temp)
  }

  async create() {
    await fssp.saveOrUpdateFieldSetting(this.data as any)
    this.$message.success(this.$t('save_success'))
  }

  renderBody() {
    return (
      <blank-view mainStyle={{ 'background': '#fff', 'box-shadow': 'none', 'padding': '16px' }}>
        <div class="blue-title" style="margin-bottom: 16px;">
          {this.$t('page_business_custom_field_setting')}
        </div>
        <a-button type="primary" onclick={this.create} style="margin-bottom: 16px">
          {this.$t('page_bom_save')}
        </a-button>
        <ml-table
          columns={this.columns}
          dataSource={this.data}
          loading={this.loading}
          size="small"
          rowKey="code"
          pagination={false}
          style="width:100%"
        />
      </blank-view>
    )
  }

  render() {
    return (
      <div class="billSetting-body">
        <a-layout style="height: 100%">
          <a-layout-sider width="260" style="background: #fff;" class="no-fix-sider">
            <div style="padding: 8px;">
              <left-tree page="fieldSetting" menuId={this.menuId} onChange={(value) => this.getTableList(value)}/>
            </div>
          </a-layout-sider>
          <div v-resize={'x'}></div>
          <a-layout-content style={{ paddingLeft: '8px', height: '100%', background: '#fff' }}>
            {this.renderBody()}
          </a-layout-content>
        </a-layout>
      </div>
    )
  }
}

